import { Level } from "docx";
import {PermissionCodes} from "../../utils/enums";

const DISPLAY_MODE = {
	TABLE: "table",
	GRID: "grid",
};

const menuItems = (navigate) => [
	{
		icon: "home",
		text: "Home",
		title: "Home",
		link: "/home/",
		customItems: [],
		superAdminOnly: false,
		permissionCode: "HOME",
	},
	{
		icon: "aiChat",
		text: "Agents",
		link: "/v2/agentsView",
		customItems: [],
		superAdminOnly: false,
		permissionCode: "AGENTS_VIEW",
	},
	{
		icon: "bolt",
		text: "Automations",
		customItems: [
			{ text: "Workflows", link: "/v2/workflows", onClick: () => navigate("/v2/workflows"), permissionCode: "DATA_CONTACTS" },
			{ text: "Blast Campaigns", link: "/v2/blast-campaigns", onClick: () => navigate("/v2/blast-campaigns"), permissionCode: "BLAST_CAMPAIGNS_VIEW" },
		],
		superAdminOnly: false,
		permissionCode: "DATA_CONTACTS",
	},
	{
		icon: "data_table",
		text: "Knowledge",
		customItems: [
			{ text: "Drives", link: "/v2/drives", onClick: () => navigate("/v2/drives"), permissionCode: "DATA_CONTACTS" },
			{ text: "Knowledge Hub", link: "/v2/knowledge", onClick: () => navigate("/v2/knowledge"), permissionCode: "DATA_CONTACTS" },
		],
		superAdminOnly: false,
		permissionCode: "DATA_CONTACTS",
	},
	{
		icon: "person",
		text: "Contacts",
		link: "/v2/ucp",
		customItems: [],
		superAdminOnly: false,
		permissionCode: "DATA_CONTACTS",
	},
	{
		icon: "shield",
		text: "Admin",
		customItems: [
			{ text: "Users", link: "/v2/user-management", onClick: () => navigate("/v2/user-management"), permissionCode: "USER_MANAGEMENT_VIEW" },
			{ text: "Roles and permissions", link: "/v2/user-management/roles", onClick: () => navigate("/v2/user-management/roles"), permissionCode: "ROLES_VIEW" },
			{ text: "Departments", link: "/v2/departments", onClick: () => navigate("/v2/departments"), permissionCode: "DEPARTMENTS_VIEW" },
			{ text: "Dashboards", link: "/dashboards", onClick: () => navigate("/dashboards"), permissionCode: PermissionCodes.DASHBOARDS_VIEW },
		],
		superAdminOnly: true,
		permissionCode: "USER_MANAGEMENT_VIEW",
	},
	{
		icon: "domain",
		text: "Workspace",
		title: "Workspace",
		link: "/v2/workspace",
		customItems: [],
		superAdminOnly: false,
		permissionCode: "WORKSPACE_VIEW",
	},
];

const settingsItems = (navigate, handleSignOut, handleProfile) => [
  {
    icon: "widgetChat",
    text: "Chat",
    customItems: [],
  },
  {
	icon: "support",
	text: "Support"
  },
  {
    icon: "avatar",
    text: "User",
    customItems: [
      { text: "Profile", onClick: handleProfile },
	  { text: "Log Out", onClick: handleSignOut },
    ],
  },
];

const accountItems = (handleSignOut, handleCustomAccountModal, showHelpButton) => [
  {
    icon: "",
    text: "Switch Accounts",
    onClick: handleCustomAccountModal,
  },
  {
    icon: "logoutAvatar",
    text: "Log Out",
    onClick: handleSignOut,
  },
   {
     icon: "Support",
     text: "Support",
     onClick: showHelpButton,
   },
];

const templateEditor = {
	options: {
		version: "latest",
		appearance: {
		  theme: "modern_light",
		},
		user: {
		  id: "GCF",
		},
		features: {
		  userUploads: {
			enabled: true,
			search: true,
		  },
		},
		id: "editor",
		projectId: 250235,
	  }
}

export { menuItems, settingsItems, accountItems, templateEditor, DISPLAY_MODE };